<template>
<!-- 视频管理 Tab -->
  <div id="videoList">
    <div class="allSearch">
      <div class="newSearch d_flex">
        <div style="width: auto;white-space: normal">
          <p>
            <input class="allInput" placeholder="项目" type="text" v-model="searchData.name">
          </p>
          <p>
            <abbr class="d_i">
              <allSelect :chooseData="fieldsList" :needReturn="'id'" :placeholder="'请选择领域'" :matchValue="'name'" :showValue="'{{name}}'" v-model="searchData.fieldId">
              </allSelect>
            </abbr>
          </p>
          <p>
            <abbr class="d_i">
              <allSelect :chooseData="indicationsList" :needReturn="'id'" :placeholder="'请选择适应症'" :matchValue="'name'" :showValue="'{{name}}'" v-model="searchData.indicationId">
              </allSelect>
            </abbr>
          </p>
          <button class="redButton" @click="getList(1)">搜索</button>
        </div>
        <div style="width: auto">
          <button class="redButtonTwo" @click="newVideos">新建</button>
        </div>
      </div>
    </div>
    <div class="allTablePlace">
      <div>
        <table cellspacing="0" class="allTable" style="table-layout: fixed;">
          <thead>
            <tr>
              <th>项目</th>
              <th>Gallery ID</th>
              <th>领域</th>
              <th>适应症</th>
              <th>创建时间</th>
              <th>更新时间</th>
              <th>是否置顶</th>
              <th>操作</th>
            </tr>
          </thead>
          <tbody>
            <template v-if="myList.length > 0">
              <tr :key="index" v-for="(item, index) in myList">
                <td width="10%" class="NoWrap" :title="item.name">{{item.name}}</td>
                <td width="15%" class="NoWrap" :title="item.galleryId">{{item.galleryId}}</td>
                <td width="15%" class="NoWrap" style="max-width: 250px" :title="item.fieldNames">{{item.fieldNames}}</td>
                <td width="15%" class="NoWrap" :title="item.indicationNames">{{item.indicationNames}}</td>
                <td width="15%">{{item.createTime ? $commonJs.returnNewDate(item.createTime) : ''}}</td>
                <td width="15%">{{item.updateTime ? $commonJs.returnNewDate(item.updateTime) : ''}}</td>
                <td width="5%">{{item.showOrder == '-1' ? '是' : '否'}}</td>
                <td width="10%"><div class="icon more iconfont icongengduo moreOperations">
                  <ul>
                    <!-- <li @click="viewListItem(item)">查看</li> -->
                    <li @click="editListItem(item)">编辑</li>
                    <li @click="deleteDraftItem(item)">删除</li>
                  </ul>
                </div></td>
              </tr>
            </template>
            <template v-else>
              <tr>
                <td style="border: none; text-align: center;" :colspan="8">暂无数据</td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
      <page v-if="totalPage !== 0" :totalCount="totalCount" v-on:on-getList="getList($event)" :totalPage="totalPage" :page="page" :explain="0"></page>
    </div>
    <!-- 新建项目 -->
    <model v-if="showModel" :buttonType="0" :title="modelTitle" :minWidth="'500px'" v-on:on-cancel="cancelModel()" v-on:on-confirm="confirModel()">
      <div style="width:100%; box-sizing:border-box; padding:10px 40px;">
        <ul class="allUL">
          <li>
            <span style="font-size:16px"><i class="colorRed m_r_5">*</i>项目名称</span>
            <input maxlength="50" v-model="modelData.name" type="text" class="allInput" style="width: calc(100% - 110px); margin-left: -30px;" placeholder="请输入名称" />
          </li>
          <li>
            <span style="font-size:16px"><i class="colorRed m_r_5">*</i>Gallery ID</span>
            <input v-model="modelData.galleryId" type="text" class="allInput" style="width: calc(100% - 110px); margin-left: -30px;" placeholder="请输入Gallery ID" />
          </li>
          <li>
            <span style="font-size:16px"><i class="colorRed m_r_5">*</i>领域</span>
            <span style="width: calc(100% - 110px); margin-left: -30px;">
              <allSelect :multiple="true" :width="302" v-on:on-change="changeField" :chooseData="fieldsListNew" :needReturn="'id'" :placeholder="'请选择领域'" :matchValue="'name'" :showValue="'{{name}}'" v-model="modelData.fieldId">
              </allSelect>
            </span>
          </li>
          <li>
            <span style="font-size:16px"><i class="colorRed m_r_5">*</i>适应症</span>
            <span style="width: calc(100% - 110px); margin-left: -30px;">
              <allSelect :multiple="true" :width="302" :chooseData="indicationsListNew" :needReturn="'id'" :placeholder="'请选择适应症'" :matchValue="'name'" :showValue="'{{name}}'" v-model="modelData.indicationId">
              </allSelect>
            </span>
          </li>
          <li>
            <span style="font-size:16px"><i class="colorRed m_r_5">*</i>是否置顶</span>
            <span style="width: calc(100% - 110px);max-width: 340px;margin-left: -30px;">
              <input :disabled="modelType == 'view'" v-model="modelData.showOrder" id="isOnTop" class="allSwitch" type="checkbox" >
              <label for="isOnTop"></label>
            </span>
          </li>
        </ul>
      </div>
    </model>
  </div>
</template>

<script>
  export default {
    name: 'videoList',
    data () {
      return {
        CNmode: true,
        baseUrl: process.env.config.baseUrl,
        token: window.sessionStorage.getItem('token'),token: window.sessionStorage.getItem('token'),
        searchCate: [{
          id: '',
          name: '全部',
          productName: '全部'
        }],
        totalPage: 1,
        totalCount: 0,
        page: 1,
        searchData: {
          name: '',
          fieldId: '',
          indicationId: '',
          PageIndex: 1,
          PageSize: this.$commonJs.commonPageSize
        },
        myList: [],
        modelTitle: '',
        modelType: '',
        showModel: false,
        modelData: {
          id: 0,
          name: "",
          fieldId: "",
          fieldName: "",
          indicationId: "",
          indicationName: "",
          galleryId: "",
          createTime: "",
          updateTime: ""
        },
        fieldsList: [],
        fieldsListNew: [],
        indicationsList: [],
        indicationsListNew: []
      }
    },
    created () {
      // 获取视频列表
      this.getList()
      // 获取领域
      this.getFieldsList()
      // 获取适应症
      this.getIndicationsList()
    },
    methods: {
      // 获取视频列表
       getList (page = 1) {
        this.searchData.PageIndex = page
        let params = {
          name: this.searchData.name,
          fieldId: this.searchData.fieldId ? [Number(this.searchData.fieldId)] : [],
          indicationId: this.searchData.indicationId ? [Number(this.searchData.indicationId)] : [],
          paged: {
            pageIndex: this.searchData.PageIndex,
            pageSize: this.searchData.PageSize
          }
        }
        this.$axiox.post(`/api/VideoManagement/Query`, params).then(res => {
          console.log(res, 'getList')
          if (res.data) {
            this.myList = res.data.map(val => {
              return {
                fieldNames: val.fields.map(val => val.name).join(','),
                indicationNames: val.indicationDatas.map(val => val.name).join(','),
                ...val
              }
            })
            console.log(this.myList, 'getList')
            this.totalPage = Math.ceil(res.total / this.searchData.PageSize)
            this.totalCount = res.total
          } else {
            this.myList = []
            this.totalPage = 0
            this.totalCount = 0
          }
        })
      },
      // 新建项目
      newVideos () {
        this.modelTitle = '新建项目'
        this.modelType = 'new'
        this.showModel = true
      },
      confirModel () {
        console.log(this.modelData, 'confirModel')
        this.modelData.name = this.modelData.name.trim()
        if (this.modelData.name === '' || this.modelData.fieldId === '' || this.modelData.indicationId === '' || this.modelData.galleryId === '') {
          this.$commonJs.alertTips({
            type: 'error',
            title: '失败',
            content: '请检查必填项',
            stayTime: 5
          })
          return
        }
        let reg = /^[A-Za-z0-9]+$/
        if (!reg.test(this.modelData.galleryId)) {
          this.$commonJs.alertTips({
            type: 'error',
            title: '失败',
            content: '请输入正确的Gallery ID',
            stayTime: 5
          })
          return
        }
        if (this.modelType == 'new') {
          let params = {
            name: this.modelData.name,
            fieldIds: this.modelData.fieldId.split(',').map(val => Number(val)),
            indicationIds: this.modelData.indicationId.split(',').map(val => Number(val)),
            galleryId: this.modelData.galleryId,
            showOrder: this.modelData.showOrder ?  -1 : 0
          }
          console.log(params, 'confirModel---params')
          this.$axiox.post(`/api/VideoManagement/AddVideoManagement`, params).then(res => {
            console.log(res, 'confirModel----res')
            // 获取轮播图列表
            this.getList(1)
            this.showModel = false
          })
        } else if (this.modelType == 'edit') {
          let params = {
            id: this.modelData.id,
            name: this.modelData.name,
            fieldIds: this.modelData.fieldId.split(',').map(val => Number(val)),
            indicationIds: this.modelData.indicationId.split(',').map(val => Number(val)),
            galleryId: this.modelData.galleryId,
            showOrder: this.modelData.showOrder ?  -1 : 0
          }
          console.log(params, 'confirModel---params')
          this.$axiox.put(`/api/VideoManagement/UpdateVideoManagement`, params).then(res => {
            console.log(res, 'confirModel----res')
            // 获取视频列表
            this.getList(1)
            this.showModel = false
          })
        }
      },
      cancelModel () {
        this.showModel = false
      },
      getVideoItemById (id) {
        this.$axiox.get(`/api/VideoManagement/GetVideoManagement/${id}`).then(res => {
          console.log(res, 'getVideoItemById---res')
          this.modelData = {
            id: res.id,
            name: res.name,
            fieldId: res.fieldIds ? res.fieldIds.join(',') : '',
            indicationId: res.indicationIds ? res.indicationIds.join(',') : '',
            galleryId: res.galleryId,
            showOrder: res.showOrder == -1 ? true : false
          }
          console.log(this.modelData, 'this.modelData')
        })
      },
      // 编辑项目
      editListItem (item) {
        this.getVideoItemById(item.id)
        this.modelTitle = '编辑项目'
        this.modelType = 'edit'
        this.showModel = true
        console.log(item, 'editListItem')
      },
      // 删除轮播图
      deleteDraftItem (item) {
        console.log(item, 'deleteDraftItem')
        this.$commonJs.doubleComfirm({
          content: '是否确定删除此项目？',
          successFun: msg => {
            this.$axiox.del('/api/VideoManagement/DeleteVideoManagement/' + item.id).then(msg => {
              this.$commonJs.alertTips({
                type: 'success',
                title: '成功',
                content: '删除成功',
                stayTime: 5
              })
              // 获取视频列表
              this.getList(1)
            })
          },
          errorFun: msg => {
          }
        })
      },
      // 获取领域
      getFieldsList () {
        this.$axiox.get(`/api/Dict/GetFields`).then(res => {
          console.log(res, 'getFieldsList')
          this.fieldsListNew = res
          this.fieldsList = [
            {
              id: 0,
              name: '全部',
            },
            ...res
          ]
        })
      },
      // 获取适应症
      getIndicationsList (ids = []) {
        console.log(ids, 'ids-------99999999999')
        let params = ids
        this.$axiox.post(`/api/Dict/GetIndications`, params).then(res => {
          console.log(res, 'getIndicationsList')
          this.indicationsListNew = res
          this.indicationsList = [
            {
              id: 0,
              fieldId: '',
              name: '全部',
            },
            ...res
          ]
        })
      },
      changeField () {
        console.log(this.modelData.fieldId, 'this.modelData.fieldId')
        this.modelData.indicationId = ''
      }
    },
    watch: {
      showModel (newData) {
        if (!newData) {
          this.modelData = {
            id: 0,
            name: "",
            fieldId: "",
            fieldName: "",
            indicationId: "",
            indicationName: "",
            galleryId: "",
            createTime: "",
            updateTime: ""
          }
        }
      },
      "searchData.fieldId" (newData) {
        console.log(newData, 'searchData.fieldId')
        this.searchData.indicationId = ''
        let ids = [newData]
        if (!newData) {
          ids = []
        } else {
          ids = [newData]
        }
        console.log(ids, 'ids')
        // 获取适应症
        this.getIndicationsList(ids)
      },
      "modelData.fieldId" (newData) {
        console.log(newData, 'modelData.fieldId')
        // let ids = [newData]
        // if (!newData) {
        //   ids = []
        // } else {
        //   ids = [newData]
        // }
        // console.log(ids, 'ids')
        let ids = []
        if (newData) {
          ids = newData.split(',').map(val => Number(val))
          console.log(ids, 'ids')
        }
        // 获取适应症
        this.getIndicationsList(ids)
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/videoManager/videoList.vue